import { Button, Carousel } from 'antd';
import React, { useEffect, useMemo, useRef, useState } from 'react';

export default function TextScroll({
    textButton = "",
    content = [],
}) {
    
    const [index, setIndex] = useState(0);
    const [animate, setAnimate] = useState(false);
    const [duration, setDuration] = useState(0);

    const containerRef = useRef(null);
    const textRef = useRef(null);
    const timerRef = useRef(null);
    const observerRef = useRef(null);

    const WAIT_TIME = 5000;

    // const items = Array.isArray(content) ? content : [content];
    const items = useMemo(() => {
        return Array.isArray(content)
            ? content.filter(Boolean)
            : (content ? [content] : []);
    }, [content]);
    const currentText = items[index] || "";

    const clearTimer = () => {
        if (timerRef.current) {
            clearTimeout(timerRef.current);
            timerRef.current = null;
        }
    };

    const nextContent = () => {
        setIndex((prev) => (prev + 1) % items.length);
    };

    // ✅ MUCH SLOWER + READABLE
    const calculateDuration = (distance) => {
        const MIN_DURATION = 8;   // never too fast
        const MAX_DURATION = 25;  // cap

        const base = distance / 35; // LOWER = slower scroll

        return Math.min(Math.max(base, MIN_DURATION), MAX_DURATION);
    };

    const checkAndAnimate = () => {
        if (!containerRef.current || !textRef.current) return;

        const containerWidth = containerRef.current.clientWidth;
        const textWidth = textRef.current.scrollWidth;

        clearTimer();

        if (textWidth > containerWidth) {

            const distance = textWidth - containerWidth;

            const time = calculateDuration(distance);

            setDuration(time);
            setAnimate(true);

        } else {

            setDuration(0);
            setAnimate(false);

            // short text → wait 30s then next
            timerRef.current = setTimeout(() => {
                nextContent();
            }, WAIT_TIME);
        }
    };

    useEffect(() => {
        checkAndAnimate();

        if (observerRef.current) {
            observerRef.current.disconnect();
        }

        observerRef.current = new ResizeObserver(() => {
            checkAndAnimate();
        });

        if (containerRef.current) {
            observerRef.current.observe(containerRef.current);
        }

        return () => {
            clearTimer();
            if (observerRef.current) {
                observerRef.current.disconnect();
            }
        };

    }, [index, items?.length]);

    const handleAnimationEnd = () => {
        clearTimer();

        // long text finished → wait 30s → next
        timerRef.current = setTimeout(() => {
            nextContent();
        }, WAIT_TIME);
    };

    return (
        <div
            className='esi-std-white-space p-3 rounded-lg flex items-center overflow-hidden'
            style={{ backgroundColor: "var(--secondary-bg-color)" }}
        >

            {/* Button */}
            {currentText?.trim() && (
                <Button className='text-[14px] cursor-auto select-none md:text-[15px] esi-std-button rounded-tl-none rounded-br-none !w-fit'>
                    {textButton}
                </Button>
            )}

            {/* Scroll container */}
            <div
                ref={containerRef}
                className="ms-5 overflow-hidden whitespace-nowrap w-full"
            >
                <div
                    key={index}
                    ref={textRef}
                    className={`esi-news-title inline-block ${
                        animate ? 'scroll-anim' : ''
                    }`}
                    style={{
                        animationDuration: `${duration}s`
                    }}
                    onAnimationEnd={handleAnimationEnd}
                >
                    {currentText}
                </div>
            </div>
        </div>
    );
}





export const TextScrolls = ({
    textButton = "",
    contents = [],
    onClickItem= () => {}
}) => {

    return (
        <div
            className="esi-std-white-space p-3 rounded-lg flex items-center overflow-hidden"
            style={{
                backgroundColor:
                    "var(--secondary-bg-color)"
            }}
        >

            <Button className="text-[14px] cursor-auto select-none md:text-[15px] esi-std-button rounded-tl-none rounded-br-none !w-fit">
                {textButton}
            </Button>

            {/* Container */}
            <div
                className="ms-5 overflow-hidden whitespace-nowrap w-full relative"
            >


                {/* Text */}
                <div
                >
                    <Carousel
                        className='esi-scroll-text-news-main-carousel'
                        // responsive={{
                        //     xxs: {
                        //         slidesToShow: 1,
                        //     },
                        //     sm: {
                        //         slidesToShow: 1,
                        //     },
                        // }}
                        slidesToShow={1}
                        draggable
                        autoplay
                        slidesToScroll={1}
                        dots={false}
                        swipeToSlide
                    >
                        {
                            contents.map((item) => {
                                return <div className='cursor-pointer select-none esi-news-card' onClick={() => {
                                    onClickItem(item);
                                }}>
                                    <div className="text-start text-black md:text-black absolute left-[24px] bottom-[6px] md:relative md:left-0 md:bottom-0 esi-news-card-title max-w-[calc(100%-24px*2)] md:max-w-[100%] mt-3-">
                                        <p className="truncate w-full">
                                        {item?.title}
                                        </p>
                                    </div>
                                </div>;
                            })
                        }
                    </Carousel>
                    {/* <p>
                        {content}
                    </p> */}
                </div>

            </div>

        </div>
    );
};
